import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { NavLink, useLocation } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import isAccess from "../../utils/checkAccess";
import { sideBarOpener } from "../../Actions/HeaderAction";
import "./SideBarMobile.scss";

const SideBarMobile = () => {
  const dispatch = useDispatch();
  const { sideBarMobile } = useSelector((state) => state.HeaderReducer);
  const location = useLocation();

  const handleClose = () => dispatch(sideBarOpener(false));

  // Close sidebar automatically on route change
  useEffect(() => {
    handleClose();
  }, [location]);

  // Decode token safely
  let decodedToken = null;
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) decodedToken = jwtDecode(token);
  } catch {
    decodedToken = null;
  }

  // Helper to check access
  const getViewAccess = (moduleName) => {
    if (!decodedToken) return false;
    const { view } = isAccess(decodedToken.userRole, moduleName);
    return view;
  };

  // Navigation items (with conditional access)
  const navItems = [
    { to: "/Dashboard", label: "Dashboard", icon: "floor" },
    { to: "/manageUser", label: "User Management", icon: "mangeUser", access: getViewAccess("User Management") },
    { to: "/customer", label: "Customer Management", icon: "customer", access: getViewAccess("Customer Management") },
    { to: "/buildingManagement", label: "Building Management", icon: "proj" },
    { to: "/floorManagement", label: "Floor Management", icon: "floormangement", access: getViewAccess("Floor Management") },
    { to: "/device", label: "Device Management", icon: "deviceMangement" },
  ];

  return (
    <Modal
      open={sideBarMobile}
      onClose={handleClose}
      className="sideBar_menu_mobile"
    >
      <Box
        sx={{
          width: 180,
          background: "#fff",
          height: "100%",
          outline: "none",
        }}
      >
        <ul className="sideBar_nav_listing">
          {navItems
            .filter((item) => item.access !== false)
            .map(({ to, label, icon }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <span className={icon}></span>
                  <span>{label}</span>
                </NavLink>
              </li>
            ))}
        </ul>
      </Box>
    </Modal>
  );
};

export default SideBarMobile;
